import type { SpecsDisplayMethod } from "../types";

export const SPECS_DISPLAY_METHODS: readonly SpecsDisplayMethod[] = [
  "colorPicker",
  "colorPalette",
  "icon",
  "none",
];
